import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=621e829c&scoped=true&"
import script from "./tongji.vue?vue&type=script&lang=ts&"
export * from "./tongji.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e829c",
  null
  
)

export default component.exports